import React from "react";
import { GatsbyImage, getImage, StaticImage } from "gatsby-plugin-image";
import proRightWhite from '../../images/arrow-right-white.svg';
import '../../sass/components/flexibleModules/_components.fullWidthGenericSection.scss';

const FullWidthGenericSection = ({ data }) => {

    const scrollToRef = (ref) => {
        if (ref) {
            window.scrollTo({
                top: document.querySelector(ref).offsetTop - 100,
                left: 0,
                behavior: 'smooth'
            });
        }
    }

    return (
        <div className={`cp-flexibleFullWidthGenericSection l--sectionPadding ${data.overrideClass ? data.overrideClass : "l-noOverride"}`} style={{ backgroundColor: `${data.backgroundColor}` }}>
            <div className="cp-flexibleFullWidthGenericSection__inner l--flex" style={{ maxWidth: `${data.maxWidth ? (data.maxWidth / 16 + "rem") : ""}`, margin: "0 auto" }}>
                <div className="cp-flexibleFullWidthGenericSection__left">
                    <h2 dangerouslySetInnerHTML={{ __html: data.fullWidthGenericSectionTitle }} />
                    {data.fullWidthGenericSectionTeaser &&
                        <p dangerouslySetInnerHTML={{ __html: data.fullWidthGenericSectionTeaser }} />
                    }
                    {data.fullWidthGenericSectionLink &&
                        <>
                            {data.fullWidthGenericSectionLink.url === '#anchorTop' ?
                                <div className="l-relativeButton">
                                    <button onClick={() => scrollToRef(`.cp-halfHalfMarketocomponent`)} className="l-button">
                                        <span>{data.fullWidthGenericSectionLink.title}</span>
                                        {data.overrideClass === 'l-LightText' || data.overrideClass === 'l-textLinkSection' ?
                                            <StaticImage src="../../images/arrow-pro-right.svg" alt=""></StaticImage>
                                            :
                                            <StaticImage src="../../images/arrow-right-white.svg" alt=""></StaticImage>
                                        }
                                    </button>
                                    <button onClick={() => scrollToRef(`.cp-halfHalfMarketocomponent`)} className="l-button l-backgroundHover">
                                        <span>{data.fullWidthGenericSectionLink.title}</span>
                                        {data.overrideClass === 'l-LightText' || data.overrideClass === 'l-textLinkSection' ?
                                            <StaticImage src="../../images/arrow-pro-right.svg" alt=""></StaticImage>
                                            :
                                            <StaticImage src="../../images/arrow-right-white.svg" alt=""></StaticImage>
                                        }
                                    </button>
                                </div>
                                :
                                <div className="l-relativeButton">
                                    <a href={data.fullWidthGenericSectionLink.url} alt={data.fullWidthGenericSectionLink.target} className="l-button">
                                        <span>{data.fullWidthGenericSectionLink.title}</span>
                                        <img src={proRightWhite} alt="" />
                                    </a>
                                    <a href={data.fullWidthGenericSectionLink.url} alt={data.fullWidthGenericSectionLink.target} className="l-button l-backgroundHover">
                                        <span>{data.fullWidthGenericSectionLink.title}</span>
                                        <img src={proRightWhite} alt="" />
                                    </a>
                                </div>
                            }
                        </>
                    }
                </div>
                <div className="cp-flexibleFullWidthGenericSection__right">
                    {data.fullWidthGenericSectionImage &&
                        <GatsbyImage image={getImage(data.fullWidthGenericSectionImage.gatsbyImage)} alt={data.fullWidthGenericSectionImage.altText} />
                    }
                </div>
            </div>
        </div>
    );
}

export default FullWidthGenericSection;